export default "__VITE_ASSET__b95b1466__"